import React, { useState } from 'react';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import './InformationRequest.scss';

const API_URL = process.env.REACT_APP_API_URL;

const InformationRequest = () => {
  const [formData, setFormData] = useState({
    tcKimlik: '',
    dogumTarihi: {
      gun: '',
      ay: '',
      yil: ''
    },
    email: '',
    ad: '',
    soyad: '',
    telefon: '',
    il: '',
    ilce: '',
    disKapiNo: '',
    icKapiNo: '',
    cevapYontemi: [],
    dosya: null,
    basvuruTipi: '',
    basvuruMetni: '',
    vekilTc: '',
    vekilAd: '',
    vekilSoyad: '',
    vekilEmail: '',
    vekilAdres: '',
    vekilIsAdres: '',
    vekilTelefon: '',
    vekilFaks: ''
  });

  // Input validation functions
  const validateTcKimlik = (value) => {
    // Sadece rakam ve 11 karakter
    return value.replace(/[^0-9]/g, '').slice(0, 11);
  };

  const validatePhone = (value) => {
    // Sadece rakam, boşluk, tire, parantez - maksimum 15 karakter
    return value.replace(/[^0-9\s\-\(\)]/g, '').slice(0, 15);
  };

  const validateName = (value) => {
    // Sadece harfler, boşluk ve Türkçe karakterler - maksimum 50 karakter
    return value.replace(/[^a-zA-ZçğıöşüÇĞIİÖŞÜ\s]/g, '').slice(0, 50);
  };

  const validateEmail = (value) => {
    // Email formatı kontrolü - maksimum 100 karakter
    return value.toLowerCase().slice(0, 100);
  };

  const validateAddress = (value) => {
    // Genel adres alanı - maksimum 200 karakter
    return value.slice(0, 200);
  };

  const validateDoorNumber = (value) => {
    // Kapı numarası - harfler ve rakamlar - maksimum 10 karakter
    return value.replace(/[^a-zA-Z0-9çğıöşüÇĞIİÖŞÜ]/g, '').slice(0, 10);
  };

  const validateDatePart = (value, type) => {
    let numericValue = value.replace(/[^0-9]/g, '');
    
    if (type === 'day') {
      numericValue = numericValue.slice(0, 2);
      if (parseInt(numericValue) > 31) numericValue = '31';
    } else if (type === 'month') {
      numericValue = numericValue.slice(0, 2);
      if (parseInt(numericValue) > 12) numericValue = '12';
    } else if (type === 'year') {
      numericValue = numericValue.slice(0, 4);
      const currentYear = new Date().getFullYear();
      if (parseInt(numericValue) > currentYear) numericValue = currentYear.toString();
    }
    
    return numericValue;
  };

  const validateTextarea = (value, maxLength = 1000) => {
    return value.slice(0, maxLength);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // TC Kimlik kontrolü
    if (formData.tcKimlik.length !== 11) {
      alert('T.C. Kimlik Numarası 11 haneli olmalıdır.');
      return;
    }

    // Email format kontrolü
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Geçerli bir e-posta adresi girin.');
      return;
    }

    // Doğum tarihi kontrolü
    const { gun, ay, yil } = formData.dogumTarihi;
    if (!gun || !ay || !yil || gun.length < 1 || ay.length < 1 || yil.length !== 4) {
      alert('Doğum tarihi tam olarak girilmelidir.');
      return;
    }

    // Vekil TC kontrolü (eğer girilmişse)
    if (formData.vekilTc && formData.vekilTc.length !== 11) {
      alert('Vekil T.C. Kimlik Numarası 11 haneli olmalıdır.');
      return;
    }

    // Doğum tarihi formatını düzenle
    const dogum = `${formData.dogumTarihi.gun}.${formData.dogumTarihi.ay}.${formData.dogumTarihi.yil}`;
    const [g, a, y] = dogum.split('.').map(Number);
    const birthDate = (g && a && y) ? new Date(y, a - 1, g).toISOString() : null;

    const payload = {
      type: "kurum",
      tckn: formData.tcKimlik,
      name: formData.ad,
      surName: formData.soyad,
      birthDate,
      gsmNo: formData.telefon,
      eMail: formData.email,
      address: [formData.il, formData.ilce, `Dış Kapı: ${formData.disKapiNo}`, `İç Kapı: ${formData.icKapiNo}`].filter(Boolean).join(' - '),
      responseType: formData.cevapYontemi.join(','),
      file: null,
      requestType: formData.basvuruTipi,
      requestNote: formData.basvuruMetni,
      proxyTckn: formData.vekilTc || null,
      proxyName: formData.vekilAd || null,
      proxySurName: formData.vekilSoyad || null,
      proxyPhoneNo: formData.vekilTelefon || null,
      proxyFaxNo: formData.vekilFaks || null,
      proxyEMail: formData.vekilEmail || null,
      proxyAddress: formData.vekilAdres || null,
      proxyWorkAddress: formData.vekilIsAdres || null
    };

    try {
      const res = await fetch(`${API_URL}/InformationForm/PostInformationForm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (!res.ok || !data?.isSuccess) throw new Error(data?.resultMessage || 'Hata');
      alert('Başvurunuz alındı.');
    } catch (err) {
      alert('Gönderim sırasında hata oluştu: ' + err.message);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      const newCevapYontemi = checked 
        ? [...formData.cevapYontemi, value]
        : formData.cevapYontemi.filter(item => item !== value);
      
      setFormData(prev => ({
        ...prev,
        cevapYontemi: newCevapYontemi
      }));
    } else if (name.startsWith('dogum')) {
      const datePart = name.split('dogum')[1].toLowerCase();
      let validatedValue;
      
      if (datePart === 'gun') {
        validatedValue = validateDatePart(value, 'day');
      } else if (datePart === 'ay') {
        validatedValue = validateDatePart(value, 'month');
      } else if (datePart === 'yil') {
        validatedValue = validateDatePart(value, 'year');
      }
      
      setFormData(prev => ({
        ...prev,
        dogumTarihi: {
          ...prev.dogumTarihi,
          [datePart]: validatedValue
        }
      }));
    } else {
      let validatedValue = value;
      
      // Alan bazında validasyon
      switch (name) {
        case 'tcKimlik':
        case 'vekilTc':
          validatedValue = validateTcKimlik(value);
          break;
        case 'telefon':
        case 'vekilTelefon':
        case 'vekilFaks':
          validatedValue = validatePhone(value);
          break;
        case 'ad':
        case 'soyad':
        case 'vekilAd':
        case 'vekilSoyad':
          validatedValue = validateName(value);
          break;
        case 'email':
        case 'vekilEmail':
          validatedValue = validateEmail(value);
          break;
        case 'il':
        case 'ilce':
          validatedValue = validateName(value);
          break;
        case 'disKapiNo':
        case 'icKapiNo':
          validatedValue = validateDoorNumber(value);
          break;
        case 'vekilAdres':
        case 'vekilIsAdres':
          validatedValue = validateAddress(value);
          break;
        case 'basvuruMetni':
          validatedValue = validateTextarea(value, 2000);
          break;
        default:
          break;
      }
      
      setFormData(prev => ({
        ...prev,
        [name]: validatedValue
      }));
    }
  };

  return (
    <div className="information-request-page">
      <div className="container">
        <div className="row">
          <QuickMenu />
          <div className="col-md-10">
            <h2>Bilgi Edinme Kurum Başvurusu</h2>
            <div className="info-text">
              <p>
                4982 Sayılı Bilgi Edinme Hakkı Kanunu ve Bilgi Edinme Hakkı Kanununun Uygulanmasına İlişkin Esas ve Usuller Hakkında Yönetmelik'i çerçevesinde oluşturulmuştur. Bilgi ve belgeye erişim işlerini yürütmektedir.
              </p>
              <p>
                Belediyemiz web sitesinden veya bizzat başvuran herkes bu hizmetten yararlanabilir. E-posta yoluyla yapılan başvurularda T.C. Kimlik No kısmının doldurulması zorunludur. Telefonla başvuru kabul edilmemektedir.
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>T.C. Kimlik No* <small>(11 haneli)</small></label>
                <input
                  type="text"
                  name="tcKimlik"
                  required
                  value={formData.tcKimlik}
                  onChange={handleInputChange}
                  placeholder="12345678901"
                  maxLength={11}
                />
                {formData.tcKimlik && formData.tcKimlik.length !== 11 && (
                  <small style={{color: 'red'}}>T.C. Kimlik Numarası 11 haneli olmalıdır.</small>
                )}
              </div>

              <div className="form-group">
                <label>Doğum Tarihi*</label>
                <small>Gün.Ay.Yıl (Örnek: 29.05.1923) şeklinde doldurunuz</small>
                <div className="date-inputs">
                  <input
                    type="text"
                    placeholder="Gün"
                    name="dogumGun"
                    value={formData.dogumTarihi.gun}
                    onChange={handleInputChange}
                    required
                    maxLength={2}
                  />
                  <input
                    type="text"
                    placeholder="Ay"
                    name="dogumAy"
                    value={formData.dogumTarihi.ay}
                    onChange={handleInputChange}
                    required
                    maxLength={2}
                  />
                  <input
                    type="text"
                    placeholder="Yıl"
                    name="dogumYil"
                    value={formData.dogumTarihi.yil}
                    onChange={handleInputChange}
                    required
                    maxLength={4}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>E-posta*</label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="ornek@email.com"
                    maxLength={100}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Ad*</label>
                  <input
                    type="text"
                    name="ad"
                    required
                    value={formData.ad}
                    onChange={handleInputChange}
                    maxLength={50}
                  />
                </div>
                <div className="form-group">
                  <label>Soyad*</label>
                  <input
                    type="text"
                    name="soyad"
                    required
                    value={formData.soyad}
                    onChange={handleInputChange}
                    maxLength={50}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Cep Telefonu*</label>
                  <input
                    type="tel"
                    name="telefon"
                    required
                    value={formData.telefon}
                    onChange={handleInputChange}
                    placeholder="0532 123 45 67"
                    maxLength={15}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>İl</label>
                  <input
                    type="text"
                    name="il"
                    value={formData.il}
                    onChange={handleInputChange}
                    maxLength={50}
                  />
                </div>
                <div className="form-group">
                  <label>İlçe</label>
                  <input
                    type="text"
                    name="ilce"
                    value={formData.ilce}
                    onChange={handleInputChange}
                    maxLength={50}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Dış Kapı No</label>
                  <input
                    type="text"
                    name="disKapiNo"
                    value={formData.disKapiNo}
                    onChange={handleInputChange}
                    maxLength={10}
                  />
                </div>
                <div className="form-group">
                  <label>İç Kapı No</label>
                  <input
                    type="text"
                    name="icKapiNo"
                    value={formData.icKapiNo}
                    onChange={handleInputChange}
                    maxLength={10}
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Cevap Yöntemleri</label>
                <div className="checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      name="cevapYontemi"
                      value="sms"
                      onChange={handleInputChange}
                    />
                    SMS
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      name="cevapYontemi"
                      value="email"
                      onChange={handleInputChange}
                    />
                    E-posta
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label>Dosya</label>
                <input
                  type="file"
                  name="dosya"
                  onChange={handleInputChange}
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                />
              </div>

              <div className="form-group">
                <label>Başvuru Tipi*</label>
                <select
                  name="basvuruTipi"
                  required
                  value={formData.basvuruTipi}
                  onChange={handleInputChange}
                >
                  <option value="">Seçiniz</option>
                  <option value="genel">Genel Başvuru</option>
                  <option value="sikayet">Şikayet</option>
                  <option value="oneri">Öneri</option>
                </select>
              </div>

              <div className="form-group">
                <label>Başvuru Metni* <small>({formData.basvuruMetni.length}/2000 karakter)</small></label>
                <textarea
                  name="basvuruMetni"
                  required
                  value={formData.basvuruMetni}
                  onChange={handleInputChange}
                  rows={4}
                  maxLength={2000}
                />
              </div>

              <h4>Vekil Bilgileri (İsteğe Bağlı)</h4>
              
              <div className="form-group">
                <label>Vekil T.C. Kimlik No <small>(11 haneli)</small></label>
                <input
                  type="text"
                  name="vekilTc"
                  value={formData.vekilTc}
                  onChange={handleInputChange}
                  maxLength={11}
                />
                {formData.vekilTc && formData.vekilTc.length > 0 && formData.vekilTc.length !== 11 && (
                  <small style={{color: 'red'}}>Vekil T.C. Kimlik Numarası 11 haneli olmalıdır.</small>
                )}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Vekil Adı</label>
                  <input
                    type="text"
                    name="vekilAd"
                    value={formData.vekilAd}
                    onChange={handleInputChange}
                    maxLength={50}
                  />
                </div>
                <div className="form-group">
                  <label>Vekil Soyadı</label>
                  <input
                    type="text"
                    name="vekilSoyad"
                    value={formData.vekilSoyad}
                    onChange={handleInputChange}
                    maxLength={50}
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Vekil E-posta</label>
                <input
                  type="email"
                  name="vekilEmail"
                  value={formData.vekilEmail}
                  onChange={handleInputChange}
                  maxLength={100}
                />
              </div>

              <div className="form-group">
                <label>Vekil Adresi</label>
                <textarea
                  name="vekilAdres"
                  value={formData.vekilAdres}
                  onChange={handleInputChange}
                  rows={2}
                  maxLength={200}
                />
              </div>

              <div className="form-group">
                <label>Vekil İş Adresi</label>
                <textarea
                  name="vekilIsAdres"
                  value={formData.vekilIsAdres}
                  onChange={handleInputChange}
                  rows={2}
                  maxLength={200}
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Vekil Telefon No</label>
                  <input
                    type="tel"
                    name="vekilTelefon"
                    value={formData.vekilTelefon}
                    onChange={handleInputChange}
                    maxLength={15}
                  />
                </div>
                <div className="form-group">
                  <label>Vekil Faks No</label>
                  <input
                    type="tel"
                    name="vekilFaks"
                    value={formData.vekilFaks}
                    onChange={handleInputChange}
                    maxLength={15}
                  />
                </div>
              </div>

              <div className="form-actions">
                <button type="submit" className="submit-button">
                  Başvuruyu Gönder
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InformationRequest;